module.exports = __webpack_public_path__ + "static/img/23澜扩.e4d96bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/23澜扩.jpg
// module id = 4m/j
// module chunks = 1